(function($) {
    /*
     * Vetology.FullTextSearch widget
     *
     * @description This is the widget for the FullTextSearch Results page,
     *              which is accessible from the image manager
     */

    $.widget(
        'Vetology.FullTextSearch',
        {
            options: {
                FullTextSearchResults: {}
            },
            _init: function()
            {
                $("body").VetologyCache();
                this.options.FullTextSearchResults = $("#fts-results-page").data('full_text_search_results');
                this._updateImages('withCloselyMatchedImage');
                this._updateImages('withoutCloselyMatchedImage');
                this._loadEventHandlers();
             },
            _loadEventHandlers: function()
            {
                this._on(this.element, {
                    "click .fts-matched-img": this._onClickMatchedImg
                });
                this._on(this.element, {
                    "click #paypal-for-submit-to-vetologist": this._onClickPaypalForSubmitToVetologist
                });
                this._on(this.element, {
                    "click #submit-to-vetologist": function(event) {
                        this._onClickSubmitToVetologist(event);
                        return false;
                    }
                });
                this._on(this.element, {
                    "click .btn.click-to-show": function(event) {
                        event.stopImmediatePropagation();
                        this._switchResutlTypes(event);
                        return true;
                    }
                })
            },

            /**
             * @description update image placemarks with the actual images retrieved
             *
             * @param group
             * @private
             */
            _updateImages: function(group)
            {
                let o = this;
                let imgs = o.options.FullTextSearchResults[group];
                $.each(imgs, function(i, img) {
                    $.when($("body").VetologyCache('imageThumbsReady', img.crypt)).then(
                        function(thumbData) {
                        o._updateImage(thumbData, img.image_id);
                    });
                });
            },
            /**
             * @description update the placemarker thumbnail with the actual image that arrived
             *
             * @param thumbData
             * @param imageID
             * @private
             */
            _updateImage: function(thumbData, imageID)
            {
                let $img = $("#" + imageID);
                if ($img.length) {
                    if(thumbData.sidebar_left){
                        $img.attr("src", thumbData.sidebar_left);
                    }
                }

            },
            /**
             * @description Generate url and navigate to a new page showing matched comparison report
             *
             * @param event
             * @private
             */
            _onClickMatchedImg: function(event)
            {
                let o = this;

                event.stopImmediatePropagation();
                let $img = $(event.target);

                let target = $img.data('target_crypt');
                let src = $img.data('source_crypt');

                o.options.report_attempt = {
                    src: src,
                    th: 0,
                    target: target,
                };
                $("body").Vetology("vetologyLoadStart");
                // get report URL
                $.ajax(
                    {
                        type: 'GET',
                        url: '/patient-manager/get-report?source_id=' + src + '&th=0&target_id=' + target,
                        dataType: 'JSON',
                        success: function(data){
                            $("body").Vetology("vetologyLoadEnd");
                            if(data.active) {
                                // add keywords to query string
                                const keywords = o.options.FullTextSearchResults.keywords;
                                const diagnosisKeyword = o.options.FullTextSearchResults.diagnosisKeyword;

                                // add keywords to URL for highlighting
                                let url = 'https://' + window.location.hostname + '/patient-manager?view=iv&id=' + data.report;
                                url += "&keywords=" + encodeURI(keywords) + "&diagnosis-keyword=" + encodeURI(diagnosisKeyword);
                                window.open(url, "_blank");
                            } else {
                                // current license doesn't allow viewing of this particular report
                                let msg = "Your current license does not allow you to view this report.  Please check your license status.";
                                $("body").Vetology("vetologyShowDialog", 'Error:', msg, "error");
                            }
                        }
                    }
                );
            },
            _onClickPaypalForSubmitToVetologist: function(event) {
                event.stopImmediatePropagation();
                let o = this;
                let $el = $(event.currentTarget);
                $.when(o._saveRoiImage(event))
                .then(function(success, textStatus) {
                    if (success) {

                        let data = {
                            plan: $el.data("plan"),
                            blocks: "",
                            target: "",
                            rate: 0,
                            cid: $el.data("cid"),
                            question: $el.data("question")
                        };
                        $("body").Vetology("vetologyLoadStart", "<strong>Please wait:</strong> We are now redirecting you to PayPal to complete the payment");
                        $.ajax(
                            {
                                type: 'GET',
                                url: "/patient-manager/get-report-plan",
                                dataType: 'JSON',
                                data: data,
                                success: function (data) {
                                    $(data.form).append($("<input type='hidden' name='question' value='" + $el.data('question') + "'/>"));
                                    $("#payment-processing").html(data.form);
                                    $(".on_purchasing").submit();
                                }
                            }
                        );
                    }
                });

            },
            _onClickSubmitToVetologist: function(event) {
                event.stopImmediatePropagation();
                let o = this;

                $.when(o._saveRoiImage(event))
                    .then(function(success, textStatus) {
                        if (success) {
                            let $el = $(event.currentTarget);
                            let url = $el.data('url');
                            window.open(url, "_blank");
                        } else {
                            $("body").Vetology("vetologyShowDialog", "Error:", textStatus, "error");

                        }
                    });
           },
            _saveRoiImage: function(event) {
                let deferred = new $.Deferred();

                let $el = $(event.currentTarget);

                $.post("/patient-manager/save-roi-image",
                    {
                        case_id: $el.data('case'),
                        question: $el.data('question'),
                        _token: $el.data('token')
                    }, "json"
                ).done(function(data, textStatus, jqXHR) {
                    data = JSON.parse(data);
                    deferred.resolve(data.success, data.error);
                }).fail(function(jqXHR, textStatus, errorThrown) {
                    deferred.resolve(false, errorThrown);
                });

                return deferred.promise();
            },

            /**
             * @description handler for clicking on 'Click to show' button
             * @param event
             * @private
             */
            _switchResutlTypes: function(event) {
                const $btn = $(event.currentTarget);
                const $showingBtn = $btn.closest(".image-type-selector").find(".btn.showing");

                // hide current shows results, and show hidden results
                $("." + $showingBtn.data('show')).addClass('hidden');
                $("." + $btn.data('show')).removeClass('hidden');

                // switch button text/color
                $btn.removeClass('click-to-show').addClass('showing').text("Showing");
                $showingBtn.removeClass('showing').addClass('click-to-show').text('Click to show');
            }
        }
    );
})(jQuery);
